// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"60548eb7","499":"02af74a7","686":"11a437e5","755":"07e6a881","858":"f6cb1507"}[chunkId] + ".chunk.js";
};